import React, { useEffect } from "react";
import EventoVisualizarController from "../controller/evento-visualizar.controller";
import If from "../../../../../vendors/components/If";
import { Card } from "primereact/card";
import AnexoVisualizar from "../../../../components/anexo/AnexoVisualizar";
import NormaDefinitivaController from "../controller/norma-definitiva.controller";

interface Props {
  controller: EventoVisualizarController;
  normaDefinitiva?: string;
}

export default function NormaDefinitiva({
  controller,
  normaDefinitiva,
}: Props) {
  const evento = controller.evento;
  const _controller = new NormaDefinitivaController();

  useEffect(() => {
    if (controller.tab === "norma-definitiva") {
      _controller.obterNormaDefinitiva(evento.codAudienciaPublica);
    }
  }, [controller.tab]);
  return (
    <>
      <If condition={controller.tab === "norma-definitiva"}>
        <div className="py-4 px-4">
          <h3>Norma Definitiva</h3>
        </div>
        <div className="evento-vis-card-tab">
          <div className="evento-norma-definitiva">
            <If condition={!!_controller.lista && _controller.lista.length > 0}>
              {!!_controller.lista &&
                _controller.lista.map((m: any, xindex: any) => (
                  <AnexoVisualizar
                    key={`norma-definitiva-${xindex}`}
                    showDownload={true}
                    handleDownload={(e: any) => {
                      controller.downloadNormaDefinitiva(m.codNormaDefinitiva);
                    }}
                    anexo={{ noAnexo: m.noAnexo }}
                  />
                ))}
            </If>
            <If
              condition={(!_controller.lista || _controller.lista.length === 0) && !normaDefinitiva}
            >
              <h4 className="text-center">Nenhum dado encontrado</h4>
            </If>
          </div>
        </div>
        {normaDefinitiva && (
          <div className="py-2 px-4">
            <b>Link Norma Definitiva: </b>
            <a
              href={normaDefinitiva}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              {normaDefinitiva}
            </a>
          </div>
        )}
      </If>
    </>
  );
}
